import React, { useEffect, useState } from "react";
import "../../../css/Infos.css";
import {
  Button,
  Grid,
  TextField,
  Card,
  CircularProgress,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";

import { Link } from "react-router-dom";

function FAQ() {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      name: {
        fontSize: 16,
        textAlign: "left",
        color: "white",
        padding: "10px",
        backgroundColor: "#857A73",
        opacity: "70%",
        margin: 0,
      },
      pos: {
        marginBottom: 12,
      },
    })
  );
  const classes = useStyles();

  useEffect(() => {
    getFaqs();
  }, []);

  const [isReady, setIsReady] = useState(-1);
  const [faqs, setFaqs] = useState([]);
  const [query, setQuery] = useState("");

  const onChangeQuery = (e) => {
    setQuery(e.target.value);
  };
  const searchOnEnter = (e) => {
    if (e.key === "Enter") {
      searchFaqs();
    }
  };

  const getFaqs = async () => {
    let requestURL = window.$apiURL.toString() + "faqs";
    let requestOptions = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };
    const responsePromise = await fetch(requestURL, requestOptions);
    const data = await responsePromise.json();
    setFaqs(data);
    setIsReady(1);
  };

  const searchFaqs = async () => {
    let requestURL;
    if (query.length === 0) {
      requestURL = window.$apiURL.toString() + "faqs";
    } else {
      requestURL = window.$apiURL.toString() + "faqs/search/" + query;
    }
    setIsReady(3);
    setFaqs([]);
    let requestOptions = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };
    const responsePromise = await fetch(requestURL, requestOptions);
    const data = await responsePromise.json();
    setFaqs(data);
    if (data.length === 0) {
      setIsReady(2);
    } else {
      setIsReady(1);
    }
  };

  const faqCards = Object.keys(faqs).map((key) => (
    <Grid item xs={12} key={key}>
      <Link to={"/FAQ/" + faqs[key].id} style={{ textDecoration: "none" }}>
        <Card variant="outlined" style={{ minWidth: "100%" }}>
          <Typography
            className={classes.name}
            color="textSecondary"
            gutterBottom
            align="right"
          >
            {faqs[key].faq_title}
          </Typography>
        </Card>
      </Link>
    </Grid>
  ));
  // Affichage de la page
  if (isReady === -1) {
    return (
      <div style={{ paddingTop: "50%" }}>
        <CircularProgress style={{ color: "#857A73" }} />
      </div>
    );
  } else if (isReady === 1) {
    return (
      <div>
        <Container component="main" maxWidth="xs" className="divClients">
          <Typography
            component="h4"
            variant="h4"
            style={{ paddingBottom: "20%" }}
          >
            FAQ
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={9} style={{ paddingBottom: "10%" }}>
              <TextField
                variant="outlined"
                label="Recherche"
                value={query}
                onChange={(e) => onChangeQuery(e)}
                onKeyPress={(e) => searchOnEnter(e)}
              />
            </Grid>
            <Grid item xs={3}>
              <Button style={{ height: "56px" }} onClick={searchFaqs}>
                <SearchIcon />
              </Button>
            </Grid>
            {faqCards}
          </Grid>
        </Container>
      </div>
    );
  } else if (isReady === 2) {
    return (
      <div>
        <Container component="main" maxWidth="xs" className="divClients">
          <Typography
            component="h4"
            variant="h4"
            style={{ paddingBottom: "20%" }}
          >
            FAQ
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={9} style={{ paddingBottom: "10%" }}>
              <TextField
                variant="outlined"
                label="Recherche"
                value={query}
                onChange={(e) => onChangeQuery(e)}
                onKeyPress={(e) => searchOnEnter(e)}
              />
            </Grid>
            <Grid item xs={3}>
              <Button style={{ height: "56px" }} onClick={searchFaqs}>
                <SearchIcon />
              </Button>
            </Grid>
            <Grid>
              <Typography
                component="h6"
                variant="h6"
                style={{ paddingBottom: "10%" }}
              >
                Aucune FAQ trouvée
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  } else if (isReady === 3) {
    return (
      <div>
        <Container component="main" maxWidth="xs" className="divClients">
          <Typography
            component="h4"
            variant="h4"
            style={{ paddingBottom: "20%" }}
          >
            FAQ
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={9} style={{ paddingBottom: "10%" }}>
              <TextField
                variant="outlined"
                label="Recherche"
                value={query}
                onChange={(e) => onChangeQuery(e)}
              />
            </Grid>
            <Grid item xs={3}>
              <Button style={{ height: "56px" }} onClick={searchFaqs}>
                <SearchIcon />
              </Button>
            </Grid>
            <Grid>
              <CircularProgress style={{ color: "#857A73" }} />
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  } else {
    return (
      <div style={{ paddingTop: "50%" }}>
        <CircularProgress style={{ color: "#857A73" }} />
      </div>
    );
  }
}

export default FAQ;
